import { render, staticRenderFns } from "./Membership.vue?vue&type=template&id=fc631b38&scoped=true&"
import script from "./Membership.vue?vue&type=script&lang=js&"
export * from "./Membership.vue?vue&type=script&lang=js&"
import style0 from "./Membership.vue?vue&type=style&index=0&id=fc631b38&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc631b38",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})
